import { DateTime } from 'luxon';

export const MED_WITH_SECONDS: Intl.DateTimeFormatOptions =
  DateTime.DATETIME_MED_WITH_SECONDS;
